var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingbasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0006 21.3334L34.334 45.3334M47.6673 21.3334L37.0006 2.66675M2.33398 21.3334H55.6673M6.33398 21.3334L10.6007 41.0667C10.85 42.2896 11.5202 43.3862 12.4947 44.1658C13.4692 44.9454 14.6863 45.3586 15.934 45.3334H42.0673C43.315 45.3586 44.5321 44.9454 45.5066 44.1658C46.4811 43.3862 47.1513 42.2896 47.4006 41.0667L51.934 21.3334M9.00065 33.3334H49.0006M10.334 21.3334L21.0006 2.66675M21.0006 21.3334L23.6673 45.3334",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbasket);
export default __webpack_public_path__ + "static/media/shoppingbasket.6dc30d07405e457a37a1f988ee6359c7.svg";
export { ForwardRef as ReactComponent };